import Col from "react-bootstrap/Col";
import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";
import Button from "react-bootstrap/Button";
import SidebarCard from "./SidebarCard";
import { SidebarList, ListItem } from "./SidebarList";
import { Tag, TagCloud } from "./TagCloud";
import PopularPostList from "./PopularPostList";
import { useContext, useState } from "react";
import { BlogContext } from "../../context/blog";
import { blogFetcher } from "../../api/requests";
import { useHistory } from "react-router-dom";

export default function BlogSidebar({ showPopularPosts = "", link = "" }) {
  const {
    blogCategories,
    blogTags,
    updateTotalCount,
    updatePaginationInfo,
    updateBlogPosts,
    setLoading,
  } = useContext(BlogContext);
  const [searchItem, setSearchItem] = useState("");
  const history = useHistory();

  const handleSearch = async () => {
    setLoading(true);

    try {
      const res = await blogFetcher.getSearch(searchItem);

      if (res) {
        link && history.push("/blog");
        updateBlogPosts(res);
        updateTotalCount(res.count);
        updatePaginationInfo(res);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleCatClick = async (cat) => {
    setLoading(true);

    try {
      const res = await blogFetcher.getPostsByCategory(cat);

      if (res) {
        updateBlogPosts(res);
        updateTotalCount(res.count);
        updatePaginationInfo(res);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const popularPosts = showPopularPosts ? (
    <SidebarCard title="پست های مرتبط">
      <PopularPostList />
    </SidebarCard>
  ) : (
    ""
  );
  return (
    <>
      <Col md={4} className="text-right">
        <SidebarCard noTitle>
          <InputGroup>
            <InputGroup.Append>
              <Button onClick={handleSearch} variant="secondary">
                جستجو
              </Button>
            </InputGroup.Append>
            <FormControl
              value={searchItem}
              onChange={(e) => setSearchItem(e.target.value)}
              type="text"
              placeholder=""
            />
          </InputGroup>
        </SidebarCard>

        {blogCategories.count > 0 && (
          <SidebarCard title="دسته بندی ها">
            <SidebarList>
              {blogCategories.results?.map((item, index) => (
                <ListItem
                  onClick={() => handleCatClick(item.id)}
                  key={index}
                  name={item.name}
                  link={link}
                />
              ))}
            </SidebarList>
          </SidebarCard>
        )}

        {/* <SidebarCard title="آرشیو">
          <SidebarList>
            <ListItem name=" آذر, 1376" />
            <ListItem name=" آبان, 1376" />
            <ListItem name="مهر, 1376" />
          </SidebarList>
        </SidebarCard> */}

        {blogTags.count > 0 && (
          <SidebarCard title="تگ ها">
            <TagCloud>
              {blogTags.results?.map((item, index) => (
                <Tag key={index} name={item.name} />
              ))}
            </TagCloud>
          </SidebarCard>
        )}

        {popularPosts}

        {/* <SidebarCard title="خبرنامه">
          <InputGroup>
            <InputGroup.Append>
              <Button variant="secondary">
                عضویت <FontAwesomeIcon icon={faArrowRight} />
              </Button>
            </InputGroup.Append>
            <FormControl type="email" placeholder="ایمیل خود را وارد کنید..." />
          </InputGroup>
        </SidebarCard> */}

        {/* <SidebarCard title="Meta">
          <SidebarList>
            <ListItem name="Log in" />
            <ListItem name="Entries RSS" />
            <ListItem name="Comments RSS" />
            <ListItem name="WordPress.org" />
          </SidebarList>
        </SidebarCard> */}
      </Col>
    </>
  );
}
